import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';

export function CampaignErrorBoundary(): JSX.Element {
  const error = useRouteError();
  const message = isRouteErrorResponse(error) ? error.statusText : 'Unable to load this campaign.';
  return <section className="error-boundary"><h2>Campaign error</h2><p>{message || 'Request failed.'}</p><Link className="btn btn-primary" to="..">Back to campaigns</Link></section>;
}
